import React from 'react';
import QvFeedbackForm from '../components/sections/QvFeedbackForm';

class Feedback extends React.Component {
  render() {
    return (
      <QvFeedbackForm className="illustration-section-01" />
    );
  }
}

export default Feedback;
